import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { formatNumber, parseDate } from "@/lib/utils";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type A5DerivativeBarriers = {
  id: number;
  structured_product_id?: number;
  structured_product_name?: string;
  barrier_date?: Date;
  recall_barrier?: string;
  capital_risk_barrier?: string;
  coupon_barrier?: number;
  coupon_value?: number;
  payment_date?: Date;
  a5_time_serie_file_id?: number;
  created_at: Date;
  updated_at: Date;
};

export const derivative_barriers_columns: ColumnDef<A5DerivativeBarriers>[] = [
  {
    accessorKey: "id",
    header: () =>
      i18n.t("a5_derivative_barriers.columns.id", {
        ns: "tables",
        defaultValue: "Id",
      }),
  },
  {
    accessorKey: "structured_product_name",
    header: () =>
      i18n.t("a5_derivative_barriers.columns.structured_product_name", {
        ns: "tables",
        defaultValue: "Produit structuré",
      }),
    cell: ({ row }) => {
      return (
        <ExternalLink
          href={toWorkspacePath(
            `/admin/a5/a5_static_data/${row.original.structured_product_id}`,
          )}
          className="text-xs"
          underline="hover"
        >
          {row.getValue("structured_product_name")}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "barrier_date",
    header: () =>
      i18n.t("a5_derivative_barriers.columns.barrier_date", {
        ns: "tables",
        defaultValue: "Date d'observation",
      }),
    cell: ({ row }) => {
      return (
        <div className="whitespace-nowrap">
          {parseDate(String(row.getValue("barrier_date")))}
        </div>
      );
    },
  },
  {
    accessorKey: "payment_date",
    header: () =>
      i18n.t("a5_derivative_barriers.columns.payment_date", {
        ns: "tables",
        defaultValue: "Date de paiement",
      }),
    cell: ({ row }) => {
      return (
        <div className="whitespace-nowrap">
          {parseDate(String(row.getValue("payment_date")))}
        </div>
      );
    },
  },
  {
    accessorKey: "coupon_barrier",
    header: () => (
      <div className="text-right">
        {i18n.t("a5_derivative_barriers.columns.coupon_barrier", {
          ns: "tables",
          defaultValue: "Barrière du coupon",
        })}
      </div>
    ),
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {formatNumber(row.getValue("coupon_barrier"))}
        </div>
      );
    },
  },
  {
    accessorKey: "coupon_value",
    header: () => (
      <div className="text-right">
        {i18n.t("a5_derivative_barriers.columns.coupon_value", {
          ns: "tables",
          defaultValue: "Valeur du coupon",
        })}
      </div>
    ),
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {formatNumber(row.getValue("coupon_value")) + "%"}
        </div>
      );
    },
  },
  {
    accessorKey: "recall_barrier",
    header: () => (
      <div className="text-right">
        {i18n.t("a5_derivative_barriers.columns.recall_barrier", {
          ns: "tables",
          defaultValue: "Barrière de callabilité",
        })}
      </div>
    ),
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {formatNumber(row.getValue("recall_barrier"))}
        </div>
      );
    },
  },
  {
    accessorKey: "capital_risk_barrier",
    header: () => (
      <div className="text-right">
        {i18n.t("a5_derivative_barriers.columns.capital_risk_barrier", {
          ns: "tables",
          defaultValue: "Barrière protection du capital",
        })}
      </div>
    ),
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {formatNumber(row.getValue("capital_risk_barrier"))}
        </div>
      );
    },
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <div className="flex gap-3 justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];

// export const derivative_barrierss_audit_columns = getAuditColumns<A5DerivativeBarriers>(derivative_barrierss_columns)
